import { useEffect } from "react";
import { PlusIcon } from "lucide-react";
import { Link } from "react-router";

import { Column, Text, TopbarContainer, TopbarTitle } from "@/components";
import { JobForm } from "@jobs/JobForm";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useSetTitle } from "@/hooks/useSetTitle";
import { useCreateJob } from "@/hooks/mutations/useCreateJob";
import { useGetCachedCompaniesSummary } from "@/hooks/sets/useGetCachedCompaniesSummary";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";

export const JobCreatePage = () => {
  const { mutate: createJob, isPending, isError } = useCreateJob();
  const currentCompanyId = useCurrentCompanyId();
  const companies = useGetCachedCompaniesSummary();

  const currentCompany = companies.find(
    (company) => company.id === currentCompanyId,
  );

  useSetTitle({
    enabled: !!currentCompany,
    // NOTE: The title won't be updated if the company is not found.
    title: `${currentCompany?.name ?? "Company"} | Create Job`,
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.JOB_CREATE);
  }, []);

  if (!currentCompany) {
    // TODO: Error state.
    return null;
  }

  return (
    <>
      <TopbarContainer>
        <TopbarTitle className="!text-slate-500">
          <Link
            className="hover:underline"
            // TODO: Should really have a util that serves as a source of truth for the routes.
            to={`/companies`}
          >
            Companies
          </Link>{" "}
          /{" "}
          <Link
            className="hover:underline"
            // TODO: Should really have a util that serves as a source of truth for the routes.
            to={`/companies/${currentCompanyId}`}
          >
            {currentCompany.name}
          </Link>{" "}
          / <span className="text-slate-700">Create job</span>
        </TopbarTitle>
      </TopbarContainer>
      <Column className="max-h-[calc(100vh-5rem)] gap-10 overflow-y-auto p-10">
        <Column className="gap-2">
          <p className="text-3xl font-semibold text-slate-700">Create job</p>
          <Text variant="small">
            Define job details, compensation, and the job description
          </Text>
        </Column>
        <JobForm
          mutationFn={createJob}
          isPending={isPending}
          isError={isError}
          submitButtonIcon={<PlusIcon className="h-4 w-4" />}
          submitButtonText="Create job"
        />
      </Column>
    </>
  );
};
